import { getSourceEntreeFromLocation } from "@/helpers/entrySource";

export function pushMatomoEvent(eventName, payload = {}) {
  window._mtm = window._mtm || [];
  window._mtm.push({
    event: eventName,
    ...payload,
  });
}

const TYPE_SOIN_MAP = {
  0: "dentaire",
  1: "optique",
  2: "generaliste",
  3: "hospitalier",
};

const TYPE_TARIFICATION_MAP = {
  CentPourCent: "100_sante",
  TarifMaitrise: "tarif_maitrise",
  TarifLibre: "tarif_libre",
};

const TYPE_PRESTATION_MAP = {
  ConsultationChirurgienDentiste: "consultation_dentiste",
  Detartrage: "detartrage",
  Implant: "implant",
  CouronneCeramoMetalliqueCentPourCentSante: "couronne_incisive",
  CouronneCeramoMetalliqueTarifMaitrise: "couronne_premolaire",
  CouronneCeramoMetalliqueTarifLibre: "couronne_molaire",
  TarifNonDefiniTotal: "couronne_incisive",
  TarifNonDefiniSemi: "couronne_premolaire",
  TarifDefini: "couronne_molaire",
  OrthodontieRembourseeParSecuriteSociale: "orthodontie_remboursee",
  OrthodontieNonRembourseeParSecuriteSociale: "orthodontie_non_remboursee",
  ConsultationOphtalmologique: "consultation_ophtalmo",
  MontureVerresSimplesHorsCentPourCentSante: "monture_verres_simples",
  MontureVerresComplexesHorsCentPourCentSante: "monture_verres_complexes",
  Lentilles: "lentilles",
  ChirurgieRefractive: "chirurgie_refractive",
  ConsultationGeneraliste: "consultation_generaliste",
  Dermatologue: "consultation_dermato",
  Gynecologue: "consultation_gyneco",
  PediatreMoinsDeuxAns: "consultation_pediatre_0_2",
  PediatreDeuxSixAns: "consultation_pediatre_2_6",
  PediatreSixSeizeAns: "consultation_pediatre_6_16",
  Cardiologue: "consultation_cardio",
  ChambreParticuliereNuitee: "chambre_nuitee",
  ChambreAmbulatoire: "chambre_ambulatoire",
  AccompagnementEnfant: "accompagnement_enfant",
};

export function normalizeTrackingValue(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function mapTypeSoin(typeDepenseIndex) {
  return TYPE_SOIN_MAP[typeDepenseIndex] || "na";
}

export function mapTypeTarification(tarification) {
  return TYPE_TARIFICATION_MAP[tarification] || "na";
}

export function mapTypePrestation(prestation) {
  const key = prestation?.key;
  const name = prestation?.name;

  if (key && TYPE_PRESTATION_MAP[key]) {
    return TYPE_PRESTATION_MAP[key];
  }

  return normalizeTrackingValue(name || key || "na") || "na";
}

export function computeMontantTotal(montantDepense = 0, sousPrestations = []) {
  if (Array.isArray(sousPrestations) && sousPrestations.length > 0) {
    return sousPrestations.reduce((sum, item) => sum + (Number(item?.montant) || 0), 0);
  }

  return Number(montantDepense) || 0;
}

export function mapEtatOptam(isOptam) {
  return isOptam ? 1 : 0;
}

export function buildLabel({ typeSoin, typePrestation, typeTarification = "na", etatOptam = null, includeTarification = true, includeOptam = false }) {
  const parts = [typeSoin || "na", typePrestation || "na"];

  if (includeTarification) {
    parts.push(typeTarification || "na");
  }

  if (includeOptam && etatOptam !== null && etatOptam !== undefined) {
    parts.push(`optam_${etatOptam}`);
  }

  return parts.join("_");
}

export function pushSimulationEvent({ event, action, label, payload = {}, value = null }) {
  const sourceEntree = payload?.source_entree || getSourceEntreeFromLocation();
  const eventPayload = {
    category: "simulateur_sante",
    action,
    label,
    source_entree: sourceEntree,
    ...payload,
  };

  if (value !== null && value !== undefined) {
    eventPayload.value = value;
  }

  pushMatomoEvent(event, eventPayload);
}

export default {
  pushMatomoEvent,
  normalizeTrackingValue,
  mapTypeSoin,
  mapTypeTarification,
  mapTypePrestation,
  computeMontantTotal,
  mapEtatOptam,
  buildLabel,
  pushSimulationEvent,
};
